import {Chip, Listbox, ListboxItem, Popover, PopoverContent, PopoverTrigger} from "@heroui/react";
import {parseMessage} from "./ChatArea";
import axios from "axios";


export const CheckIcon = ({size, height, width, ...props}) => {
	return (
		<svg
			fill="none"
			height={size || height || 24}
			viewBox="0 0 24 24"
			width={size || width || 24}
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default function MActions(props) {
	const item = function (i) {
		if (i.action_type === 9) {
			var obj = JSON.parse(i.extra)
			i.from_id = obj.sender_uid
			i.from_name = obj.sender_name
			i.extra = obj.awards[0].gift_name + ' * ' + obj.awards[0].num
			i.gift_name = '发红包'
		}
		if (i.action_type === 2) {
			i.extra = ''
		}
		if (i.action_type === 3) {
			i.extra = ''
		}
		return i
	}(Object.assign({}, props.item))
	return (
		<div key={item.id ?? index} className="mt-1 break-all " id={item.id} >
			<span className={`font-light tabular-nums text-gray-500 mr-1.5 align-middle ${isMobile()?'':'w-[64px]'} inline-block`}>
				{timestampToDate(item.created_at).toLocaleTimeString()}
			</span>

			{!props.hide_medal && item.medal_level !== undefined && item.medal_level !== 0 && (
				<Chip
					className="mr-1.5 align-middle"
					startContent={
						item.guard_level ? (
							<img
								src={getGuardIcon(item.guard_level)}
								alt="guard"
								className="w-4 h-4 inline"
							/>
						) : (
							<CheckIcon size={16} />
						)
					}
					variant="faded"
					onClick={(e) => {
						e.stopPropagation();
						toSpace(item.medal_liver);
					}}
					style={{
						background: getColor(item.medal_level),
						color: "white",
					}}
				>
					{item.medal_name}
					<span className="ml-1 text-xs font-bold px-1.5 py-0.5 rounded-full">
						{item.medal_level}
					</span>
				</Chip>
			)}
			<Popover>
				<PopoverTrigger className="align-middle">
					<span className="mr-1 font-stretch-90% text-[#006fee] align-middle cursor-pointer">
						{item.from_name}:
					</span>
				</PopoverTrigger>
				<PopoverContent>
					<Listbox
						aria-label="Actions"
						onAction={(key) => {
							if (key === "bilibili") {
								window.open(
									"https://space.bilibili.com/" +
										item.from_id,
								);
							} else if (key === "vtbcat") {
								window.open("/user/" + item.from_id);
							} else if (key === "filter") {
								setMid(item.from_id);
							}
						}}
					>
						<ListboxItem
							key="bilibili"
							className={"border-b-2 border-gray-200"}
						>
							<img
								src={"https://www.bilibili.com/favicon.ico"}
								className={"w-4 h-4 inline mr-1"}
								alt={"bilibili"}
							/>
							前往用户空间(bilibili)
						</ListboxItem>
						<ListboxItem key="vtbcat">
							<div>
								<span className={"w-4 h-4 mr-1 inline-block"}>
									🐱
								</span>
								<span>前往用户页面(vtbCat)</span>
							</div>
						</ListboxItem>
					</Listbox>
				</PopoverContent>
			</Popover>

			{/* 4. 消息内容：添加 align-middle */}
			<span className={`inline align-middle ${props.highLight?'bg-green-200':''}`} onClick={() => {
				axios
					.get(
						`/api/actions/locate?id=${item.id}&live=${item.live}&size=${localStorage.getItem('defaultPageSize')}`,
					)
					.then((response) => {
						window.open(
							`/lives/${item.live}?page=${response.data.page}&highLight=${item.id}`,
						);
					});
			}}>
				<span
					className={`transition-transform hover:text-gray-500 ml-1 ${item.action_type !== 1 ? "font-bold" : ""}`}
				>
			{/*		{GIFT_MAP.has(item.gift_name) && (
						<img
							className={"inline w-[22px] h-[22px] mr-1"}
							src={GIFT_MAP.get(item.gift_name)}
						/>
					)}*/}
					{ <span>{item.gift_name}</span>}
					<span
						dangerouslySetInnerHTML={{
							__html:

								parseMessage(
									item.extra ?? "",
									item.emotes ?? new Map(),
								),
						}}
					/>
					{item.action_type !== 1 && item.gift_amount !== 0 && (
						<span>
							*{item.gift_amount}
							{formatFloat(item.gift_price)
								? ` ￥ ${formatFloat(item.gift_price)}`
								: ""}
						</span>
					)}
				</span>
			</span>
		</div>
	);
}
